import clsx from "clsx";
import React, { FC, TextareaHTMLAttributes } from "react";

interface TextAreaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export const TextAreaField: FC<TextAreaFieldProps> = ({ ...props }) => (
  <textarea
    {...props}
    className={clsx(
      "self-stretch h-32 px-4 py-2",
      "bg-neutral-100 rounded-xl",
      "outline outline-1 outline-neutral-100",
      "text-base font-semibold font-switzer",
      "leading-tight text-zinc-900",
      "placeholder:opacity-100 w-full"
    )}
  />
);
